export default "__VITE_ASSET__Br79oqpl__"